import styled from 'styled-components/macro'

export const FlexWrapper = styled.div`
  display: flex;
  padding: 50px 0;
  flex-wrap: wrap;
  gap: 60px;
  justify-content: center;
  

  @media (max-width: 986px) {
    justify-content: center;
  }
`

export const CardsContent = styled.section`
  padding-top: 50px;
  min-height: 100vh;
`
